<template><div><h1 id="dokumententensatz" tabindex="-1"><a class="header-anchor" href="#dokumententensatz"><span>Dokumententensatz</span></a></h1>
<p>Dokumentensatz — Definition von Dokumentensätzen im Document Output</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Im Dokumentensatz wird festgelegt, welche Dokumente pro Output in einem Lauf erstellt werden sollen.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Document Output → Dokumentensätze</code></p>
<h2 id="datenfelder-linker-bereich" tabindex="-1"><a class="header-anchor" href="#datenfelder-linker-bereich"><span>Datenfelder (linker Bereich)</span></a></h2>
<dl>
<dt>Dokumentensatz</dt>
<dd>Bezeichnung des Dokumentensatzes</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung des Dokumentensatzes</dd>
<dt>Übergeordnetes Element</dt>
<dd>Das Dokument/der Knoten wird, unterhalb dem ausgewählten Knoten, in einer Baumstruktur abgelegt.</dd>
<dt>Geschäftsfall</dt>
<dd>legt fest, in welchem Bereich der Dokumentensatz genutzt werden kann (z.B. Verdankungen).</dd>
<dt>Übergeordnetes Element</dt>
<dd>Das Dokument/der Knoten wird, unterhalb dem ausgewählten Knoten, in einer Baumstruktur abgelegt.</dd>
<dt>Typ</dt>
<dd>Hier wird der Typ des Dokumentensatzes definiert. Folgende Möglichkeiten stehen zur Auswahl:
<table>
<thead>
<tr>
<th>Auswahl</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Knoten</td>
<td>erfasst einen Knoten, mit dem sich eine Baumstruktur anlegen lässt</td>
</tr>
<tr>
<td>DOCX</td>
<td>Output als Word-Dokument.</td>
</tr>
<tr>
<td>E-MAil</td>
<td>Output als E-Mail</td>
</tr>
<tr>
<td>PDF</td>
<td>Output als PDF</td>
</tr>
</tbody>
</table>
</dd>
<dt>Status</dt>
<dd>Status des Dokumentensatzes:
<table>
<thead>
<tr>
<th>Auswahl</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>aktiv</td>
<td>Der Dokumentensatz ist aktiv und kann verwendet werden (erscheint in der Auswahlliste der Dokumentensätze)</td>
</tr>
<tr>
<td>inaktiv</td>
<td>der Dokumentensatz ist inaktiv und kann nicht verwendet werden (erscheint auch nicht in der Auswahlliste der Dokumentensätze). Damit können Dokumentensätze vorbereitet werden ohne diese den Benutzern anzuzeigen.</td>
</tr>
</tbody>
</table>
</dd>
<dt>Einstellungen für PDF/Ausgabe</dt>
<dd>Gibt an, in welcher Sortierung die Dokumente auf einen spezifischen Drucker ausgedruckt werden:
<table>
<thead>
<tr>
<th>Auswahl</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>separat</td>
<td>Druckt gleiche Dokumente zusammen (ESRMG2, ESRMG2 ...).</td>
</tr>
<tr>
<td>gemischt</td>
<td>Druckt pro Empfänger verschiedene Dokumente nacheinander (StdBrief_001, MGIntForm001,ESRMG2 ...).</td>
</tr>
</tbody>
</table>
</dd>
<dt>Einstellungen für PDF/PDF-Datei</dt>
<dd>Legt fest, ob die einzelnen Outputs zu einem PDF-File zusammengefasst werden (&quot;pro Dokumentensatz&quot;) oder als einzelne Files erstellt werden (&quot;pro Dokument&quot;).
<table>
<thead>
<tr>
<th>Auswahl</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>eine</td>
<td>Die Outputs werden zu einem PDF zusammengefasst.</td>
</tr>
<tr>
<td>mehrere</td>
<td>Die Outputs werden als einzelne PDFs erstellt.</td>
</tr>
</tbody>
</table>
</dd>
<dt>Einstellungen für E-Mail/Absender</dt>
<dd>Absender des E-Mails, Auswahl aus der Wertetabelle Texte und Bilder (muss vorgängig erfasst sein).</dd>
<dt>Einstellungen für E-Mail/Betreff</dt>
<dd>Betreff des E-Mails, Auswahl aus der Wertetabelle Texte und Bilder (muss vorgängig erfasst sein).</dd>
</dl>
<div class="hint-container tip">
<p class="hint-container-title">Anmerkung</p>
<p>Hier kann das Datenfeld &quot;Salutation&quot; (Anrede) verwendet werden. Eingabesyntax:<br>Eingabe-Syntax:<br><pre class="programlisting">&lt;fieldref name=&quot;Salutation&quot;&gt; </pre></p>
</div>
<dl>
<dt>instellungen für E-Mail/BCC (E-Mail)</dt>
<dd>BCC E-Mail-Adresse als Empfänger-Adresse z.B. für Kontrolle und Testing.</dd>
</dl>
<h2 id="datenfelder-zugeordnete-dokumente" tabindex="-1"><a class="header-anchor" href="#datenfelder-zugeordnete-dokumente"><span>Datenfelder (Zugeordnete Dokumente)</span></a></h2>
<dl>
<dt>Sortierung</dt>
<dd>Position des Dokuments im Dokumentensatz</dd>
<dt>E-Mail Typ</dt>
<dd>Zeigt den Typ des zugeordneten Dokuments an (verfügbar nur bei Typ E-Mail).
<table>
<thead>
<tr>
<th>Auswahl</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>E-Mail Anhang</td>
<td>Dokument (mit Document Output aus funtrade erstellt) als Anhang.</td>
</tr>
<tr>
<td>E-Mail Datei-Anhang</td>
<td>Eine beliebige Datei als Anhang im E-Mail</td>
</tr>
<tr>
<td>E-Mail Text</td>
<td>Inhalt eines E-Mails (Body)</td>
</tr>
</tbody>
</table>
</dd>
<dt>Dokument</dt>
<dd>Zugeordnetes Dokument, Auswahl aus der Wertetabelle.</dd>
<dt>Dateiname</dt>
<dd>Dateiname für den Anhang (verfügbar nur bei Typ E-Mail Anhang)</dd>
<dt>Drucker</dt>
<dd>Auswahl eines Druckers aus der Stammtabelle.</dd>
<dt>Status</dt>
<dd>Status des zugeordneten Dokuments:
<table>
<thead>
<tr>
<th>Auswahl</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>aktiv</td>
<td>Das zugeordnete Dokument ist aktiv und wird verwendet.</td>
</tr>
<tr>
<td>inaktiv</td>
<td>Das zugeordnete Dokument ist inaktiv, wird nicht verwendet.</td>
</tr>
</tbody>
</table>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="dokumentensatz-umbenennen" tabindex="-1"><a class="header-anchor" href="#dokumentensatz-umbenennen"><span>Dokumentensatz umbenennen...</span></a></h3>
<p>Mit dieser Funktion wird der Dokumentensatz umbenannt. Es findet auch eine Anpassung aller in funtrade vorhandenen Einträge mit dem betreffenden Dokumentensatz statt.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/administration/dokumentproduktion.html" title="2. Document Output">Document Output</RouteLink></p>
</div></template>


